module.exports = __webpack_public_path__ + "static/media/Chem-2.bc45b917.svg";


//////////////////
// WEBPACK FOOTER
// ./src/core/img/subject_icons/Chem-2.svg
// module id = 893
// module chunks = 21